import { useDisclosure } from "@mantine/hooks";
import type { HTMLAttributes } from "react";
import { useState } from "react";

import { Center, Popover } from "metabase/ui";

import type { PillSize } from "../ColorPill";
import { ColorPill } from "../ColorPill/ColorPill";

import ColorSelectorPopover from "./ColorSelectorPopover";


export type ColorSelectorAttributes = Omit<
  HTMLAttributes<HTMLDivElement>,
  "onChange" | "onSelect"
>;

export interface ColorSelectorProps extends ColorSelectorAttributes {
  value: string;
  colors: string[];
  pillSize?: PillSize;
  onChange?: (newValue: string) => void;
  withinPortal?: boolean;
}

export const ColorSelector = ({
  value,
  colors,
  onChange,
  withinPortal = true,
  ...props
}: ColorSelectorProps) => {
  const [opened, { toggle, close }] = useDisclosure(false);
  // eslint-disable-next-line no-color-literals
  const [_, setSelectedColor] = useState("#000000");

  const handleColorChange = (event: any) => {
    setSelectedColor(event.target.value);
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <Popover
      withinPortal={withinPortal}
      floatingStrategy="fixed"
      opened={opened}
      onDismiss={close}
      position="bottom-start"
      trapFocus
    >
      <Popover.Target>
        <Center data-testid="color-selector-button">
          <ColorPill {...props} color={value} onClick={toggle} />
        </Center>
      </Popover.Target>
      <Popover.Dropdown>
        <ColorSelectorPopover
          value={value}
          colors={colors}
          onChange={onChange}
          onClose={close}
          data-testid="color-selector-popover"
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            padding: "14px",
            justifyContent: "center",
          }}
        >
          <div>
            <label
              style={{
                cursor: "pointer",
                marginRight: "4px",
                fontSize: "16px",
                color: "black",
              }}
              htmlFor="colorInput"
            // eslint-disable-next-line i18next/no-literal-string
            >
              Or Choose a Color:{" "}
            </label>
            <input
              type="color"
              id="colorInput"
              value={value}
              style={{
                cursor: "pointer",
              }}
              onChange={handleColorChange}
            />
          </div>
          <div
            style={{
              width: "full",
              height: "50px",
              backgroundColor: value,
              marginTop: "10px",
              // eslint-disable-next-line no-color-literals
              border: "1px solid #ccc",
            }}
          ></div>
        </div>
      </Popover.Dropdown>
    </Popover>
  );
};
